export enum RoutesEnum {
  AI_AGENT = 'ai-agent',
  AI_AGENT_CUSTOM = 'ai-agent-custom',
  AI_AGENT_STUDIO = 'ai-agent-studio',
  AI_AGENT_NEW = 'ai-agent/new',
  AI_AGENT_TEMPLATES = 'ai-agent-templates',
  AI_AGENT_KNOWLEDGE_BASE = 'ai-agent-knowledge-base',
  AI_AGENT_WIZARD = 'ai-agent-custom/wizard',
  AUTHENTICATION = 'authentication',
  DASHBOARD = 'dashboard',
  CUSTOMERS = 'customers',
  PANEL = 'panel',
  USERS = 'users',
  PROFILES = 'profiles',
  API = 'api',
  DIALER = 'dialer',
  CHAT = 'chat',
  VIRTUAL_AGENTS = 'virtual-agents',
  TEAMS = 'teams',
  HORARY = 'horary',
  HOLIDAYS = 'holidays',
  REPORT_LOGIN_LOGOUT = 'report-login-logout',
  REPORT_TEMPLATE = 'report-template',
  REPORT_CAMPAIGN = 'report-campaign',
  REPORT_CAMPAIGN_DETAILS = 'report-campaign-details',
  REPORT_PAUSE = 'report-pause',
  REPORT_AWAY = 'report-away',
  REPORT_BLOCK = 'report-block',
  REPORT_TEAMS = 'report-teams',
  REPORT_ATTENDANCES = 'report-attendance',
  REPORT_SURVEY_SATISFACTION = 'report-survey-satisfaction',
  REPORT_TEMPLATE_LIMIT = 'report-template-limit',
  REPORT_WORKFLOW_DETAILS = 'report-workflow-details',
  REPORT_CALL = 'report-call',
  REPORT_RECORD = 'report-record',
  REPORT_DIALER = 'report-dialer',
  REPORT_ALL_ATTENDANCES = 'report-all-attendance',
  REPORT_CONDITIONALS = 'report-conditionals',
  REPORT_DOWNLOAD_HISTORY = 'report-download-history',
  REPORT_CALLS_URA = 'report-calls-ura',
  REPORT_CALLS_BY_TEAM = 'report-calls-by-team',
  REPORT_TEAM_TELEPHONY = 'report-team-telephony',
  REPORT_CALLS_BY_USER = 'report-calls-by-user',
  REPORT_ASSIGNMENT = 'report-assignment',
  REPORT_AI_AGENT = 'report-ai-agent',
  FLOW = 'flow',
  WEBHOOK = 'webhook',
  WORKERFLOWS = 'workerflows',
  WORKFLOW = 'workflow',
  WORKFLOW_BUILDER = 'workflow/builder',
  WORKFLOW_WIZARD = 'workflow/wizard',
  WEBLINK = 'weblink',
  SMARTMENU = 'smart-menu',
  CHANNELS = 'channels',
  CONTACTS = 'contacts',
  PROTOCOL = 'protocol',
  TEMPLATE_HSM = 'template-hsm',
  WHATSAPP_FORMS = 'whatsapp-forms',
  TAGS = 'tags',
  TASKS = 'tasks',
  REPORT_TAGS = 'report-tags',
  REPORT_TAGS_DETAIL = 'report-tags-detail',
  TABULATION = 'tabulations',
  ACCESS_CONTROL = 'access-control',
  EMAIL = 'email',
  EMAIL_LIST = 'email-list',
  RECLAME_AQUI = 'reclame-aqui',
  RECLAME_AQUI_LIST = 'reclame-aqui-list',
  LINKEDIN_LIST = 'linkedin',
  REPORT_TABULATION = 'report-tabulation',
  PARAMETERS = 'parameters',
  GLOBAL_CONFIGURATIONS = 'global-configurations',
  ADMINISTRATION__MARKETPLACE = 'marketplace-adm',
  REPORT_SMS = 'report-sms',
  MARKETING_CAMPAIGN = 'marketing-campaign',
  DIALER_CAMPAIGN = 'dialer-campaign',
  CATALOG = 'catalog',
  MARKETING_CAMPAIGN_NEW = 'marketing-campaign/new',
  KANBAN = 'kanban',
  TELEGRAM = 'channels/telegram',
  TELEGRAM_API = 'channels/telegram/apps',
  MARKETPLACE = 'marketplace',
  INTEGRATIONS = 'integrations',
  INTEGRATIONS_MODERNA_LINK = 'integrations/moderna/link',
  SECURITY = 'security',
  IDENTITY_PROVIDERS = 'identity-providers',
  RESOURCES_GALLERY = 'resource-gallery',
  METADATA_INDICATORS = 'metadata-indicators',
  METADATA_ADVANCED_REPORTS = 'metadata-advanced-reports',
  MONITORING_AGENTS = 'monitoring-agents',
  MONITORING_TEAMS = 'monitoring-teams',
  MONITORING_CAMPAIGNS = 'monitoring-campaigns',
  MONITORING_DIALER = 'monitoring-dialer',
  MONITORING_AI_AGENT = 'monitoring-ai-agent',
  AI_AGENT_REVIEW = 'ai-agent-review',
  AI_SESSIONS = 'ai-sessions',
  AI_SESSIONS_ADMIN = 'ai-sessions-admin',
  PRIVACY_POLICY = 'privacy-policy',
  PAUSES = 'pauses',
  COST_CENTER = 'cost-center',
  TASK_CATEGORIES = 'task-categories',
  FAST_MESSAGE = 'fast_message',
  GOOD_AND_BAD_WORDS = 'good-and-bad-words',
  REPORT_CHATS = 'report-chats',
  SATISFACTION_SURVEYS = 'satisfaction-surveys',
  CAMPAIGNS_CONTACT_LIST = 'campaign-list',
  CAMPAIGNS_EMAIL = 'campaign-email',
  CAMPAIGNS_EMAIL_HEALTH = 'campaign-email-health',
  MAIL_CAPACITY = 'mail-capacity',
  SUPPORT_TICKETS_LIST = 'support_tickets_list',
  BLACKLIST = 'blacklist',
  REPORT_USER_MESSAGING = 'report-user-messaging',
  MAINTENANCE_NOTIFICATION = 'maintenance-notification',
  REQUEST_LOGS = 'request-logs',
  RCS_LIST = 'rcs',
  MS_TEAMS_LIST = 'ms-teams',
  SUPPORT_KNOWLEDGE_BASE = 'support-knowledge-base',
  QUALITY_MONITORING = 'quality-monitoring',
  FUNNEL_FORM = 'funnel-form',
}
